// Catch-all 404 — friendly, on-brand, keeps navigation available.
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const loc = useLocation();
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-950 text-white flex items-center justify-center p-6" data-testid="not-found-page">
      <div className="max-w-md w-full text-center">
        <div className="text-8xl font-black bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">404</div>
        <div className="text-xl font-black">Page not found</div>
        <div className="text-sm opacity-70 mt-2">
          Yeh page maujood nahi hai: <code className="text-rose-300 bg-slate-800 px-1.5 py-0.5 rounded text-[11px]">{loc.pathname}</code>
        </div>
        <div className="flex gap-2 justify-center mt-6">
          <button onClick={() => window.history.back()} data-testid="not-found-back"
                  className="px-4 py-2 rounded-lg bg-slate-800 border border-slate-700 text-sm font-black flex items-center gap-1">
            <ArrowLeft size={14} /> Back
          </button>
          <Link to="/" data-testid="not-found-home"
                className="px-4 py-2 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-black flex items-center gap-1">
            <Home size={14} /> Home
          </Link>
        </div>
      </div>
    </div>
  );
}
